import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../utils/api';
import LoadingSpinner from '../components/LoadingSpinner';
import Swal from 'sweetalert2';
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  Spinner,
} from 'reactstrap';

const Perfil = () => {
  const { user, changePassword } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .modern-select {
        appearance: none !important;
        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e") !important;
        background-position: right 14px center !important;
        background-repeat: no-repeat !important;
        background-size: 16px !important;
        padding-right: 40px !important;
      }
      .modern-select:hover {
        border-color: #5A0C62 !important;
        box-shadow: 0 4px 12px rgba(90, 12, 98, 0.15) !important;
        transform: translateY(-1px) !important;
      }
      .modern-select:focus {
        border-color: #DC017F !important;
        box-shadow: 0 0 0 3px rgba(220, 1, 127, 0.1) !important;
        outline: none !important;
      }
      .mobile-button {
        transition: all 0.3s ease !important;
        border-radius: 8px !important;
        font-weight: 500 !important;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
      }
      .mobile-button:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 4px 16px rgba(0,0,0,0.15) !important;
      }
      .mobile-button:active {
        transform: translateY(0) !important;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
      }
      .info-item {
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border: 1px solid #e9ecef;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 8px;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      }
      .info-item:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        border-color: #5A0C62;
      }
      .info-label {
        color: #6c757d;
        font-size: 14px;
        margin-bottom: 8px;
      }
      .info-value {
        color: #495057;
        font-size: 16px;
        font-weight: 500;
      }
      .perfil-card-header {
        background: linear-gradient(135deg, #5A0C62 0%, #DC017F 100%);
        border: none;
      }
      .perfil-card-header h3,
      .perfil-card-header h5,
      .perfil-card-header p {
        color: white !important;
      }
      .perfil-input {
        border: 2px solid #e9ecef;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        transition: all 0.3s ease;
      }
      .perfil-input:focus {
        border-color: #DC017F;
        box-shadow: 0 0 0 3px rgba(220, 1, 127, 0.1);
      }
      .badge-perfil-active {
        background-color: #5A0C62;
        color: white;
      }
      .badge-perfil-assigned {
        background-color: #6c757d;
        color: white;
      }
    `;
    document.head.appendChild(style);

    const fetchProfile = async () => {
      try {
        setLoading(true);
        const response = await authAPI.verify();
        setProfile(response.data.user);
      } catch (error) {
        console.error('Error cargando perfil:', error);
        Swal.fire({
          icon: 'error',
          title: 'No se pudo cargar el perfil',
          text: error.response?.data?.error || 'Intente nuevamente más tarde',
          confirmButtonText: 'Cerrar',
          customClass: {
            confirmButton: 'swal2-confirm-custom',
          },
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const validationErrors = {};
    if (!currentPassword) {
      validationErrors.currentPassword = 'Contraseña actual requerida';
    }
    if (!newPassword) {
      validationErrors.newPassword = 'Nueva contraseña requerida';
    }
    if (!confirmPassword) {
      validationErrors.confirmPassword = 'Confirmar nueva contraseña requerida';
    }
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      validationErrors.confirmPassword = 'Las contraseñas no coinciden';
    }
    if (newPassword && newPassword.length < 8) {
      validationErrors.newPassword = 'La contraseña debe tener al menos 8 caracteres';
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    try {
      setSaving(true);
      const result = await changePassword({ currentPassword, newPassword });

      if (result.success) {
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setErrors({});

        Swal.fire({
          icon: 'success',
          title: 'Contraseña actualizada',
          text: 'Tu contraseña fue cambiada correctamente.',
          confirmButtonText: 'Aceptar',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'No se pudo cambiar la contraseña',
          text: result.error || 'Verifica tus datos e intenta nuevamente.',
          confirmButtonText: 'Cerrar',
        });
      }
    } catch (error) {
      console.error('Error cambiando contraseña:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error al guardar la nueva contraseña.',
        confirmButtonText: 'Cerrar',
      });
    } finally {
      setSaving(false);
    }
  };

  const displayedProfile = profile || user;
  const assignedTerminals = displayedProfile?.available_terminals || [];
  const currentTerminal = displayedProfile?.terminal_name || 'No disponible';

  if (loading) {
    return (
      <>
        <div className="header pb-8 pt-5 pt-md-8" style={{ background: 'linear-gradient(135deg, #5A0C62 0%, #DC017F 100%)' }}>
          <Container fluid>
            <div className="header-body">
              <Row>
                <Col>
                  <h6 className="h2 text-white d-inline-block mb-0"></h6>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Container className="mt--8" fluid>
          <Row>
            <Col>
              <Card className="shadow">
                <CardBody className="text-center py-5">
                  <Spinner color="primary" size="lg" className="mb-3">{null}</Spinner>
                  <h5>Cargando perfil...</h5>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-8" style={{ background: 'linear-gradient(135deg, #5A0C62 0%, #DC017F 100%)' }}>
        <Container fluid>
          <div className="header-body">
            <Row>
              <Col>
                <h6 className="h2 text-white d-inline-block mb-0"></h6>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Container className="mt--8" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Mi Perfil</h3>
                    <small className="text-muted">
                      Revisa tus datos personales y administra tu contraseña.
                    </small>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="6" className="mb-3">
                    <div className="info-item">
                      <div className="info-label">Usuario</div>
                      <div className="info-value">{displayedProfile?.username || '---'}</div>
                    </div>
                  </Col>
                  <Col md="6" className="mb-3">
                    <div className="info-item">
                      <div className="info-label">Rol</div>
                      <div className="info-value text-capitalize">{displayedProfile?.rol || '---'}</div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="6" className="mb-3">
                    <div className="info-item">
                      <div className="info-label">Nombre</div>
                      <div className="info-value">{displayedProfile?.nombre || '---'}</div>
                    </div>
                  </Col>
                  <Col md="6" className="mb-3">
                    <div className="info-item">
                      <div className="info-label">Apellido</div>
                      <div className="info-value">{displayedProfile?.apellido || '---'}</div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12" className="mb-3">
                    <div className="info-item">
                      <div className="info-label">Terminal actual</div>
                      <div className="info-value">{currentTerminal}</div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="font-weight-600 text-sm text-uppercase text-muted mb-3">
                      Terminales asignadas
                    </div>
                    {assignedTerminals.length === 0 ? (
                      <div className="text-muted">No hay terminales asignadas.</div>
                    ) : (
                      <Table responsive className="align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>Terminal</th>
                            <th className="text-center">Seleccionada</th>
                          </tr>
                        </thead>
                        <tbody>
                          {assignedTerminals.map((terminal) => (
                            <tr key={terminal.id}>
                              <td>{terminal.nombre}</td>
                              <td className="text-center">
                                {terminal.nombre === currentTerminal ? (
                                  <span className="badge badge-perfil-active">Actual</span>
                                ) : (
                                  <span className="badge badge-perfil-assigned">Asignada</span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </Col>
                </Row>
                <hr />
                <Row className="mt-4">
                  <Col>
                    <h5 className="mb-3">Cambiar contraseña</h5>
                  </Col>
                </Row>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="4" className="mb-3">
                      <FormGroup>
                        <Label for="currentPassword" className="text-sm font-weight-bold">
                          Contraseña actual
                        </Label>
                        <Input
                          id="currentPassword"
                          name="currentPassword"
                          type="password"
                          placeholder="Ingrese su contraseña actual"
                          value={currentPassword}
                          onChange={(e) => setCurrentPassword(e.target.value)}
                          invalid={!!errors.currentPassword}
                          className="perfil-input"
                        />
                        {errors.currentPassword && (
                          <small className="text-danger">{errors.currentPassword}</small>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="4" className="mb-3">
                      <FormGroup>
                        <Label for="newPassword" className="text-sm font-weight-bold">
                          Nueva contraseña
                        </Label>
                        <Input
                          id="newPassword"
                          name="newPassword"
                          type="password"
                          placeholder="Ingrese la nueva contraseña"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          invalid={!!errors.newPassword}
                          className="perfil-input"
                        />
                        {errors.newPassword && (
                          <small className="text-danger">{errors.newPassword}</small>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="4" className="mb-3">
                      <FormGroup>
                        <Label for="confirmPassword" className="text-sm font-weight-bold">
                          Confirmar contraseña
                        </Label>
                        <Input
                          id="confirmPassword"
                          name="confirmPassword"
                          type="password"
                          placeholder="Confirme la nueva contraseña"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          invalid={!!errors.confirmPassword}
                          className="perfil-input"
                        />
                        {errors.confirmPassword && (
                          <small className="text-danger">{errors.confirmPassword}</small>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-right">
                      <Button
                        color="primary"
                        type="submit"
                        disabled={saving}
                        className="px-4 mobile-button"
                        style={{
                          background: 'linear-gradient(135deg, #5A0C62 0%, #DC017F 100%)',
                          border: 'none'
                        }}
                      >
                        {saving ? (
                          <>
                            <Spinner size="sm" >{null}</Spinner>
                          </>
                        ) : (
                          'Guardar contraseña'
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form>
                <div className="mt-4 px-3 py-3 bg-light border rounded">
                  <div className="text-sm font-weight-bold mb-2">Requisitos mínimos de la nueva contraseña</div>
                  <ul className="list-unstyled text-sm mb-2">
                    <li>• Mínimo 8 caracteres</li>
                    <li>• Al menos una letra mayúscula</li>
                    <li>• Al menos una letra minúscula</li>
                    <li>• Al menos un número</li>
                    <li>• Al menos un símbolo especial</li>
                  </ul>
                  <div className="text-muted text-sm mb-0">
                    Ingresa una contraseña segura y cumple todos los requisitos antes de guardar.
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Perfil;
